import EmailLink, {
  EmailLinkProps,
} from "components/UI/ContactDetails/EmailLink";
import { CONTACT_EMAIL } from "runtime-config/config";

export default function ContactEmailLink(props: Omit<EmailLinkProps, "email">) {
  return <EmailLink email={CONTACT_EMAIL} {...props} />;
}
